import React, { useEffect } from 'react';
import { setSubpage } from '../../../routes/routerSlice';
import { CalculationDetailSubpages } from '../../Calculations/calculationsLib';
import { useTemplateOrCalculation } from '../../../hooks/useTemplateOrCalculation';
import { useGetCalculationQuery } from '../apiCalculationDetail';
import LoadingIndicator from '../../../components/global/LoadingIndicator/LoadingIndicator';
import { CalculationType } from '@ydistri/api-sdk';
import { Helmet } from 'react-helmet-async';
import StoreEvaluationsSection from './StoreEvaluationsSection';
import { MainContent, MainContentWrapper } from '@ydistri/ds';
import { useAppDispatch } from '../../../store';
import { useClusterTypeReady } from './hooks/useClusterTypeReady';

const CalculationEvaluation: React.FC = () => {
  const dispatch = useAppDispatch();
  const templateOrCalculation = useTemplateOrCalculation();
  const { data: calculationData, isFetching } = useGetCalculationQuery(templateOrCalculation.id);

  //we will render stats only when clusterType (Store or StoreDepartment) has been determined
  //to know which data to load and avoid unnecessary api calls
  const clusterTypeReady = useClusterTypeReady();

  useEffect(() => {
    dispatch(setSubpage(CalculationDetailSubpages.EVALUATION));
  }, [dispatch]);

  if (isFetching) return <LoadingIndicator />;
  if (calculationData?.type !== CalculationType.Production)
    return <div>Calculation is not set as production, so it is not evaluated.</div>;

  return (
    <>
      <Helmet title={`Calculation ${templateOrCalculation.id} - Evaluation`} />
      <MainContentWrapper $flexDirection="column">
        <MainContent>{clusterTypeReady && <StoreEvaluationsSection />}</MainContent>
      </MainContentWrapper>
    </>
  );
};

export default CalculationEvaluation;
